import { c as _c } from "react/compiler-runtime";
import Head from "next/head";
type LocationType = "city" | "state" | "village" | "area" | "category";
type VillaMetaProperties = {
  title: string;
  description: string;
  locationType: LocationType | string;
  locationTitle: string;
  seoCategoryTitle?: string;
};
export const VillaMeta = t0 => {
  const $ = _c(16);
  const {
    title,
    description,
    locationType,
    locationTitle,
    seoCategoryTitle
  } = t0;
  let T0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== description || $[1] !== locationTitle || $[2] !== locationType || $[3] !== seoCategoryTitle || $[4] !== title) {
    const categorySchema = seoCategoryTitle ? {
      title: `اجاره ${seoCategoryTitle} در ${locationTitle} | رزرو آنلاین ویلا و اقامتگاه`,
      description: `رزرو و اجاره ${seoCategoryTitle} در ${locationTitle} با بهترین قیمت، پشتیبانی ۲۴ ساعته و امکان پرداخت اقساطی.`
    } : null;
    const defaultSchema = {
      title: `اجاره ویلا ${locationTitle} | اجاره ویلای ${locationTitle} با بهترین قیمت در 4 قسط`,
      description: `رزرو و اجاره ویلا‌ ${locationTitle} به صورت آنی و با بهترین قیمت مناسب جمع‌های خانوادگی و دوستانه. تنوع بیش از 1000 ویلای ${locationTitle} در اسنپ تریپ.`
    };
    const schema = {
      state: {
        title: `اجاره ویلا در ${locationTitle} | رزرو آنی ویلا و اقامتگاه با بهترین قیمت`,
        description: `اجاره ویلا در ${locationTitle} به صورت آنی | رزرو انواع ویلا، سوئیت و اقامتگاه با امکان انتخاب بر اساس ظرفیت، امکانات، منطقه و کنسلی بدون جریمه`
      },
      city: {
        title: `اجاره ویلا در ${locationTitle} | رزرو آنی ویلا و سوئیت با پرداخت قسطی`,
        description: `اجاره سوئیت و ویلا در ${locationTitle} به صورت آنلاین و در 4 قسط | انواع ویلا، سوئیت و اقامتگاه در ${locationTitle} با بهترین قیمت و پشتیبانی 24 ساعته`
      },
      village: {
        title: `اجاره ویلا و سوئیت در ${locationTitle} | اقامت در ${locationTitle} با بهترین قیمت`,
        description: `اجاره ویلا و سوئیت در ${locationTitle} با تضمین بهترین قیمت، امنیت، نظافت و تنوع اقامتگاه. رزرو آنی ویلا در ${locationTitle} با پشتیبانی 24 ساعته و لغو بدون جریمه`
      }
    };
    const getMeta = locationType_0 => categorySchema || schema[locationType_0] || defaultSchema;
    T0 = Head;
    t3 = <title>{title || getMeta(locationType as LocationType).title}</title>;
    t1 = "description";
    t2 = description || getMeta(locationType as LocationType).description;
    $[0] = description;
    $[1] = locationTitle;
    $[2] = locationType;
    $[3] = seoCategoryTitle;
    $[4] = title;
    $[5] = T0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    T0 = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t2) {
    t4 = <meta name={t1} content={t2} />;
    $[9] = t1;
    $[10] = t2;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== T0 || $[13] !== t3 || $[14] !== t4) {
    t5 = <T0>{t3}{t4}</T0>;
    $[12] = T0;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};